import { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

function Blog() {
  const [blogs, setBlogs] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {

  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });

}, []);

  useEffect(() => {
    fetch("https://swiftintelli.com/api/get_blogs.php")
      .then((res) => res.json())
      .then((data) => setBlogs(data))
      .catch((err) => {

  console.log(err);

  Swal.fire({
    icon: "error",
    title: "Failed to Load Blogs",
    text: "Unable to fetch blog data",
    confirmButtonColor: "#2563eb",
  });

});
  }, []);

  return (
    <>
      <Navbar />

      <div className="blog-page">

        {/* Hero Section */}
        <div className="blog-hero">
          <h1>SwiftIntelli Blog</h1>
          <p>Explore tutorials, guides, and insights on full-stack development, databases, DevOps, and everything in between.</p>
        </div>

        {/* Blog Grid */}
        <div className="blog-grid">
          {blogs.map((blog) => (
            <div className="blog-card" key={blog.id}>

              <div className="blog-img-wrap">
                <img src={blog.image} alt={blog.title} />
              </div>

              <div className="blog-content">
                <span>{blog.category}</span>
                <h3>{blog.title}</h3>
                <div
  className="blog-description"
  dangerouslySetInnerHTML={{
    __html: blog.description,
  }}
/>
                <button onClick={() => navigate(`/blog/${blog.slug}`)}>
                  Read More →
                </button>
              </div>

            </div>
          ))}
        </div>

      </div>

      <Footer />
    </>
  );
}

export default Blog;